export default __webpack_public_path__ + "static/media/alert.2b2329fb.svg";